import React, { Component } from 'react';
import { Button, withStyles } from 'material-ui';
import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List';
import Checkbox from '../../components/checkbox/ListCheckbox';
import Dictionary from '../../model/Dictionary';
import styles from './PassengersListStyles';
import PassengersListProps from './PassengersListProps';
import PassengersListController from './PassengersListController';
import ProgressBarCenter from '../../components/ProgressBarCenter';
import SelectedPassengers from '../../components/passengers/selectedPassengers/SelectedPassengers';
import EditRowAction from './EditRowAction';
import SeatRowAction from './SeatRowAction';
import PlusIcon from '../../icons/PlusIcon';
import TextField from '../../components/textField/TextField';
import Constants from '../../model/AppConfiguration';
import _ from 'lodash';

/**
 * ## Redux imports
 */
import * as passengersActions from '../../redux/actions/PassengersActions';
import * as flightsActions from '../../redux/actions/FlightsActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';

/**
 * ## Redux boilerplate
 */
const actions = [ passengersActions, flightsActions ];

function mapStateToProps (state) {
  let JSFlights = selectors.flights.getFlights(state.flights);
  return {
    isFetching: selectors.global.isFetching(state.global),
    passengers: selectors.passengers.getPassengers(state.passengers),
    reservationId: selectors.general.getReservationId(state.general),
    flights: selectors.flights.pairSeatsForPassengers(JSFlights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class PassengersList extends Component {
  static propTypes = PassengersListProps;

  constructor (props) {
    super(props);

    const { reservationId, flights, passengers, actions } = props;
    if (reservationId && (!passengers || !passengers.length)) {
      actions.getPassengers(reservationId);
    }

    this.state = {
      routeId: '',
      checked: [ 0 ],
      passengers: passengers || [],
      filteredPassengers: passengers || [],
      flights: flights || [],
      search: '',
    };

    this.selectPassenger = PassengersListController.selectPassenger.bind(this);
    this.onRouteIdChange = PassengersListController.onRouteIdChange.bind(this);
    this.findPassenger = _.debounce(PassengersListController.findPassenger.bind(this), 100);
    this.onRouteIdChange(props);
  }

  componentDidMount () {
    let { flights, isFetching, reservationId, actions } = this.props;

    if (!isFetching && !flights) {
      actions.getFlights(Constants.REQUEST.PASSENGERS, reservationId);
    }
  }

  componentWillReceiveProps (props) {
    let { flights, routeId, passengers, isFetching } = props;

    if (!isFetching && (routeId !== this.state.routeId || flights !== this.props.flights)) {
      this.onRouteIdChange(props);
    }

    if (passengers !== this.props.passengers) {
      this.findPassenger(this.state.search);
      this.setState({ passengers: passengers });
    }
  }

  onListItemClick = passenger => {
    const { selectable, onItemClickAction } = this.props;
    if (!selectable && onItemClickAction) {
      onItemClickAction(passenger.id);
      return;
    }
    this.selectPassenger(passenger.id);
  };

  onRowActionClick = passenger => {
    const { onRowAction, onItemClickAction } = this.props;
    if (onRowAction) {
      onRowAction(passenger.id);
      return;
    }
    if (onItemClickAction) {
      onItemClickAction(passenger.id);
    }
  };

  handleChange = name => e => {
    this.setState({ search: e.target.value });
    this.findPassenger(e.target.value);
  };

  render () {
    const {
      classes,
      RowAction,
      selectable,
      showOnlySelected,
      activePassenger,
      addNew,
      routeId,
    } = this.props;
    const { flights, search } = this.state;
    let { passengers, filteredPassengers } = this.state;

    if (!passengers || (!flights && !flights.length)) {
      return <ProgressBarCenter />;
    }

    if (passengers && passengers.length && showOnlySelected) {
      let currentFlight = flights.find(flight => flight.routeId === routeId);
      if (currentFlight && currentFlight.passengers && currentFlight.passengers.length) {
        filteredPassengers = filteredPassengers.filter(passenger =>
          currentFlight.passengers.find(flightPassenger => flightPassenger.id === passenger.id)
        );
      } else {
        filteredPassengers = [];
      }
    }

    return (
      <div className={`passengers-list ${classes.root}`} id='passengers-list'>
        {selectable ? (
          <SelectedPassengers
            flight={flights.find(f => f.routeId === this.props.routeId)}
            allPassengers={passengers}
          />
        ) : null}
        {addNew && selectable ? (
          <div className='row' style={{ marginTop: 16 }}>
            <div className='col-xl-7 col-lg-7 col-md-7 col-sm-7 col-10' style={{ padding: 0 }}>
              <TextField
                value={search}
                placeholder={Dictionary.passengers.find}
                onChange={this.handleChange('search')}
              />
            </div>
            <div
              className='offset-xl-2 offset-lg-2 offset-md-2 offset-sm-2 col-xl-3 col-lg-3 col-md-3 col-sm-3 col-2'
              style={{ padding: 0 }}
            >
              <Button
                variant='raised'
                fullWidth
                color='primary'
                onClick={() => this.onRowActionClick({ id: 0 })}
                style={{ minWidth: '100%' }}
              >
                <PlusIcon className='add-passenger-plus' />&nbsp;
                <span className='d-none d-sm-block'>{Dictionary.passengers.add}</span>
              </Button>
            </div>
          </div>
        ) : null}

        {!filteredPassengers || !filteredPassengers.length ? (
          !search ? (
            showOnlySelected ? (
              <h3 style={{ margin: 30 }}>{Dictionary.passengers.noSelectedPassengers}</h3>
            ) : (
              <h3 style={{ margin: 30 }}>{Dictionary.passengers.noPassengers}</h3>
            )
          ) : (
            <h3 style={{ margin: 30 }}>
              {Dictionary.passengers.noPassengersForSearch}
              {search}
            </h3>
          )
        ) : (
          <List style={{ width: '100%', backgroundColor: 'transparent' }}>
            {filteredPassengers.map(passenger => (
              <ListItem
                key={passenger.id}
                dense
                button
                onClick={() => this.onListItemClick(passenger)}
                className={`${classes.listItem} ${
                  passenger.id === activePassenger ? classes.active : ''
                }`}
              >
                {!selectable ? null : <Checkbox selected={passenger.selected} />}

                <ListItemText
                  primary={`${passenger.firstName} ${passenger.lastName}`}
                  secondary={passenger.relationship}
                />
                {!selectable && !RowAction ? null : selectable ? (
                  <ListItemSecondaryAction className={classes.rowAction}>
                    <div onClick={() => this.onRowActionClick(passenger)}>
                      <EditRowAction />
                    </div>
                  </ListItemSecondaryAction>
                ) : (
                  <div onClick={() => this.onRowActionClick(passenger)}>
                    <SeatRowAction passenger={passenger} />
                  </div>
                )}
              </ListItem>
            ))}
          </List>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PassengersList));



// WEBPACK FOOTER //
// ./src/containers/passengersList/PassengersList.js